import { DropDownButton } from '@replai-platform/ui-components';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { kpiUtils } from '@replai-platform/sdk';
import { FilterActions } from '../../../store/filters';
import { RootState } from '../../../store/rootReducer';
import { logEvent } from '../../../analytics';

export const ImpressionsFilterContainer = styled.div`
  padding-left: 12px;
`;

export type ImpressionsFilterProps = {
  customState?: { value: number | null; onChange: (minImpressions: number | null) => void };
};

const ImpressionsFilter: React.VFC<ImpressionsFilterProps> = ({ customState }) => {
  const dispatch = useDispatch();
  const filtering = useSelector((state: RootState) => state.filters);

  if (customState) {
    return (
      <ImpressionsFilterContainer>
        <DropDownButton
          onClickCrossButton={() => {
            customState.onChange(null);
          }}
          onConfirm={(value) => {
            customState.onChange(+value);
          }}
          hideCrossButton={customState.value === null}
          placeHolder={
            customState.value ? `> ${kpiUtils.format('impressions', customState.value)}` : 'Set min impressions'
          }
          defaultValue={customState.value ?? undefined}
          title="Min Impressions"
        />
      </ImpressionsFilterContainer>
    );
  }
  return (
    <ImpressionsFilterContainer hidden={!filtering.minImpressions}>
      <DropDownButton
        onClickCrossButton={() => {
          dispatch(FilterActions.changeMinImpressions({ value: 0, logEvent: false, removeMinImpressions: true }));
          logEvent({
            component: 'Active Filters',
            action: 'Remove Min Impressions Filter',
            category: 'user_actions',
          });
        }}
        onConfirm={(value) => {
          dispatch(FilterActions.changeMinImpressions({ value: +value, logEvent: true }));
        }}
        placeHolder={filtering.minImpressions ? `> ${kpiUtils.format('impressions', filtering.minImpressions)}` : ''}
        defaultValue={filtering.minImpressions}
        title="Min Impressions"
      />
    </ImpressionsFilterContainer>
  );
};

export default ImpressionsFilter;
